import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import { getBrowser } from './helpers/browsers'

if(process.env.MIX_ENVIRONMENT !== 'local') {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_JS_DSN,
        environment: process.env.MIX_ENVIRONMENT,
        integrations: [new VueIntegration({Vue, attachProps: true})],
        ignoreErrors: [
            "Non-Error exception captured",
            "Non-Error promise rejection captured"
        ]
    })
}

require('./polyfills')

window.csrf_token = document.querySelector('meta[name="csrf-token"]').content

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.axios.interceptors.response.use((response) => response, (error) => {
    stopLoading()

    if(axios.isCancel(error) == false) {
        return Promise.reject(error.response)
    }
})

document.body.classList.add(getBrowser())
window.browser = getBrowser()

window.Vue = require('vue')
